var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColumns(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.125 2.5H5C4.66848 2.5 4.35054 2.6317 4.11612 2.86612C3.8817 3.10054 3.75 3.41848 3.75 3.75V16.25C3.75 16.5815 3.8817 16.8995 4.11612 17.1339C4.35054 17.3683 4.66848 17.5 5 17.5H8.125C8.45652 17.5 8.77446 17.3683 9.00888 17.1339C9.2433 16.8995 9.375 16.5815 9.375 16.25V3.75C9.375 3.41848 9.2433 3.10054 9.00888 2.86612C8.77446 2.6317 8.45652 2.5 8.125 2.5ZM8.125 16.25H5V3.75H8.125V16.25ZM15 2.5H11.875C11.5435 2.5 11.2255 2.6317 10.9911 2.86612C10.7567 3.10054 10.625 3.41848 10.625 3.75V16.25C10.625 16.5815 10.7567 16.8995 10.9911 17.1339C11.2255 17.3683 11.5435 17.5 11.875 17.5H15C15.3315 17.5 15.6495 17.3683 15.8839 17.1339C16.1183 16.8995 16.25 16.5815 16.25 16.25V3.75C16.25 3.41848 16.1183 3.10054 15.8839 2.86612C15.6495 2.6317 15.3315 2.5 15 2.5ZM15 16.25H11.875V3.75H15V16.25Z",
    fill: "black",
    fillOpacity: 0.65
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColumns);
export default __webpack_public_path__ + "static/media/columns.8666827c34e3e7bfa63671fdbfaa5a71.svg";
export { ForwardRef as ReactComponent };